export default __webpack_public_path__ + "static/bg_top_waves_light-289f442c5c92cb05972afc631788e234.svg";